import { render, staticRenderFns } from "./F2.vue?vue&type=template&id=a4ae2a6e&scoped=true"
import script from "./F2.vue?vue&type=script&lang=js"
export * from "./F2.vue?vue&type=script&lang=js"
import style0 from "./F2.vue?vue&type=style&index=0&id=a4ae2a6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ae2a6e",
  null
  
)

export default component.exports